export default "__VITE_ASSET__d2c7612c__"